// Square Web Payments SDK helpers.
//
// GET /config/app returns BOTH `square.sandbox` and `square.production` id sets;
// the user's `is_test_account` (GET /account) decides which to use. NO default
// for is_test_account — until it's a definite boolean we return status
// 'pending' and never guess an environment. We pass only application_id +
// location_id to Square.payments(); the config's `environment` field is ignored.
export const SQUARE_SANDBOX_SDK = 'https://sandbox.web.squarecdn.com/v1/square.js'
export const SQUARE_PRODUCTION_SDK = 'https://web.squarecdn.com/v1/square.js'

export function resolveSquare(square, isTestAccount) {
    if (typeof isTestAccount !== 'boolean') {
        return {appId: null, locationId: null, currencyCode: null, sdkSrc: null, status: 'pending'}
    }
    const creds = isTestAccount ? square?.sandbox : square?.production
    const appId = creds?.application_id || null
    const locationId = creds?.location_id || null
    // Same block as the ids, so the wallet's currency always matches the merchant account
    // the ids point at. Was a hardcoded WALLET_CURRENCY = 'CAD' in paymentCards.jsx until
    // 2026-08-26. Falls back to CAD only so a config that predates the field can't make
    // paymentRequest() throw — the ids are what gate the form, not this.
    const currencyCode = creds?.currency_code || 'CAD'
    const sdkSrc = isTestAccount ? SQUARE_SANDBOX_SDK : SQUARE_PRODUCTION_SDK
    if (!appId || !locationId) {
        return {appId: null, locationId: null, currencyCode, sdkSrc, status: 'unavailable'}
    }
    return {appId, locationId, currencyCode, sdkSrc, status: 'ready'}
}
